import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { create } from "zustand";
const useSnackbar = create((set)=>({
        snackbars: [],
        addSnackbar: (item)=>set((state)=>{
                mixpanelEvent("Snackbar Opened", {
                    Message: item.message,
                    ...item.position && {
                        Position: item.position
                    }
                });
                return {
                    snackbars: [
                        ...state.snackbars,
                        {
                            ...item,
                            id: crypto.randomUUID()
                        }
                    ]
                };
            }),
        remove: (id)=>set((s)=>({
                    snackbars: s.snackbars.filter((t)=>t.id !== id)
                }))
    }));
export default useSnackbar;
